<script setup lang="ts">
import {SearchItem} from "@/auto-complete-searchbar/interfaces";
import SearchBarService from "@/core/services/SearchBarService";
import SearchBarAutoCompleteService from "@/auto-complete-searchbar/services/SearchBarAutoCompleteService";
import {X} from "@lucide/vue";
import categories from "@/core/factories/search-bar/CustomerQuickFilters";

const props = defineProps<{ filters: SearchItem[] }>();
const emits = defineEmits(['on-delete']);

const onDelete = (item: SearchItem) => {
    const elementIndex = SearchBarService.getItemIndex(item, props.filters);
    let copy = [...props.filters];

    if (elementIndex !== -1) {
        copy.splice(elementIndex, 1);
    }

    emits('on-delete', copy);
};

const getItemLabel = (item: SearchItem): string => {
    if (SearchBarAutoCompleteService.isAutoCompleteItem(item)) {
        return item.name;
    }

    return item.label;
};

const getFilterIcon = (item: SearchItem) => {
    if (SearchBarAutoCompleteService.isAutoCompleteItem(item)) {
        return null;
    }
    return categories.find(c => c.filters.some(f => f.queryParam === item.queryParam))?.icon ?? null;
};
</script>

<template>
  <div class="flex flex-row flex-wrap gap-2">
    <button
      v-for="(selectedFilter, index) in filters"
      :key="index"
      type="button"
      class="flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/30 text-primary text-sm font-semibold leading-tight"
      @click="onDelete(selectedFilter)"
    >
      <component :is="getFilterIcon(selectedFilter)" v-if="getFilterIcon(selectedFilter)" class="size-3.5" />
      {{ getItemLabel(selectedFilter) }}
      <X class="size-3.5" />
    </button>
  </div>
</template>
